export const board = {
  board: {
    title: "Ideas",
    columns: {
      12345: {
        title: "Column 1",
        cards: {
          987987: {
            content: "Hello, this is my first card.",
            tags: ["dev", "sprint"],
          },
          445755: {
            content: "Second cards here ... ",
            tags: ["manager"],
          },
        },
      },
      12589: {
        title: "Column 2",
        cards: {
          987323: {
            content: "this is column 2 card",
            tags: ["dev"],
          },
          343221: {
            content: "last card here ",
            tags: ["designer"],
          },
        },
      },
    },
  },
};

export const grid = 8;
export const borderRadius = 2;
